const roundedToCents = value => {
  const parsed = parseFloat(value);
  if (!value || isNaN(parsed)) return 0;
  return Math.round(parsed * 100) / 100;
};

module.exports = roundedToCents;
